import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import CanonicalTag from '@/components/CanonicalTag';
import aduSaleImage from '@/assets/adu-separate-sale.jpg';

const CanYouSellYourADUSeparatelyInCalifornia = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);

  return (
    <>
      <CanonicalTag url="https://www.udaadu.com/can-you-sell-adu-separately-california" />
      
      {/* Calendly Modal */}
      {showCalendly && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative bg-white rounded-lg w-full max-w-4xl h-full max-h-[90vh]">
            <button 
              onClick={closeCalendlyModal} 
              className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors"
            >
              ✕
            </button>
            <iframe 
              src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              title="Schedule a meeting"
            />
          </div>
        </div>
      )}
      
      <div className="min-h-screen bg-background">
        <Navigation />
        
        <main className="container mx-auto px-4 py-8">
          {/* Hero Section */}
          <div className="mb-12">
            <img 
              src={aduSaleImage} 
              alt="ADU for separate sale" 
              className="w-full h-64 md:h-96 object-cover rounded-lg mb-8"
            />
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#E4683B' }}>
              Can You Sell Your ADU Separately in California?
            </h1>
            
            <p className="text-lg md:text-xl text-white leading-relaxed mb-8">
              Understand California's recent laws regarding selling your ADU separately. 
              Get clarity on AB 1033 and condo conversion rules.
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-12">
            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                AB 1033 Explained: Selling Your ADU as a Separate Unit
              </h2>
              <p className="text-white leading-relaxed mb-6">
                California's Assembly Bill 1033, effective January 2022, allows homeowners 
                to sell their ADU separately from the main house through a condominium 
                conversion process. This groundbreaking legislation requires local jurisdictions 
                to allow ADU condo conversions, subject to specific conditions and requirements.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Condo Conversion and ADUs in California
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Converting your ADU to a separately sellable unit requires meeting condominium 
                standards, including separate utilities, proper legal descriptions, homeowners 
                association formation, and compliance with local subdivision requirements. 
                The process involves surveying, legal documentation, and approval by local authorities.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Legal Steps to Sell Your ADU Independently
              </h2>
              <p className="text-white leading-relaxed mb-6">
                To legally sell your ADU separately, you must: obtain local jurisdiction approval 
                for condo conversion, ensure separate utilities for each unit, create legal 
                property descriptions and CC&Rs, establish a homeowners association, and comply 
                with all local subdivision and condominium requirements.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Frequently Asked Questions
              </h2>
              <div className="text-white leading-relaxed space-y-6">
                <div>
                  <p className="font-semibold mb-2">Q: Can I legally sell my ADU separately from my main house?</p>
                  <p>A: Yes, under California's AB 1033, certain ADUs can be sold separately after condo conversion.</p>
                </div>
                
                <div>
                  <p className="font-semibold mb-2">Q: What steps are required for condo conversion of my ADU?</p>
                  <p>A: Approval by local jurisdictions, meeting condo standards, and obtaining separate utilities.</p>
                </div>
              </div>
            </section>
          </div>

          {/* Call-to-Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
            <Button 
              onClick={openCalendlyModal}
              className="bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-3 text-lg"
            >
              Book & Schedule
            </Button>
            <Button 
              asChild
              variant="outline"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground px-8 py-3 text-lg"
            >
              <Link to="/landing">Learn More</Link>
            </Button>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default CanYouSellYourADUSeparatelyInCalifornia;